import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useCategorizations(userID, toDefine) {
  const { data, _error, _isLoading, _isValidating, mutate } = useSWR(
    userID ? `/categorizations/${toDefine ? 'todefine' : 'defined'}` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );
  return {
    data: data,
    mutate: mutate,
  };
}

export default useCategorizations;
